import { forwardRef, useImperativeHandle } from "react";
import { ModifyResidentRef } from "../interfaces";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { useHandleResidentPortfolio } from "../../hooks/useHandleResidentPortfolio";
import { Controller } from "react-hook-form";
import UploadDocumentArea from "ui/organisms/UploadDocumentArea";
import { generalAllowedExtensions } from "app/constants/allowedExtensionsConstants";
import {
  requiredValidation,
  validateFileExtensions,
} from "ui/utils/Validators";

const ResidentPortfolioFormTemplate = forwardRef<ModifyResidentRef, {}>(
  (_, ref) => {
    const { control, submitForm } = useHandleResidentPortfolio();

    useImperativeHandle(
      ref,
      () => ({
        continue: () => submitForm(),
      }),
      [submitForm],
    );
    return (
      <View>
        <Controller
          control={control}
          name="portfolio_medias"
          defaultValue={[]}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <UploadDocumentArea
              value={value}
              onChange={onChange}
              allowedExtensions={generalAllowedExtensions}
              errorMessage={error}
            />
          )}
          rules={{
            validate: validateFileExtensions(generalAllowedExtensions),
          }}
        />
      </View>
    );
  },
);

ResidentPortfolioFormTemplate.displayName = "ResidentPortfolioFormTemplate";

export { ResidentPortfolioFormTemplate };
